export async function install(app) {
  const { sessionData } = useSessionData()
  if (!sessionData.widget?.active)
    return
  if (sessionData.widget?.options?.type)
    return
  if (!window.parent || window.parent === window)
    return

  const requestWidgetOptions = async () => new Promise((resolve) => {
    let timer = null

    const onMessage = (event) => {
      if (event.source !== window.parent)
        return
      if (event.data?.action !== 'embedContext')
        return

      window.removeEventListener('message', onMessage)
      clearTimeout(timer)
      resolve(event.data.options)
    }

    const onTimeout = () => {
      window.removeEventListener('message', onMessage)
      resolve({})
    }

    timer = setTimeout(onTimeout, 300)

    window.addEventListener('message', onMessage)
    window.parent.postMessage(
      {
        action: 'getEmbedContext',
      },
      '*',
    )
  })

  sessionData.widget.options = await requestWidgetOptions()
}
